<template>
  <div class="account-balance__get-balance-wrapper">
    <AccountBalanceChip
      class="account-balance__get-balance-info _x-large _brand"
      style="margin-left: 0.75em"
      value="23000"
      money
    >
      <template #left>
        <span class="account-balance__tabs-chips-text lighter">
          Доступно к <br> выводу
        </span>
      </template>
    </AccountBalanceChip>

    <button
      class="account-balance__get-balance base-btn base-btn--green"
      @click="$vModal.open('cash-request')"
    >
      <span class="base-btn__text">Запрос на вывод</span>
    </button>
  </div>
</template>

<script>
  import AccountBalanceChip from '@/components/balance/AccountBalanceChip';

  export default {
    name: 'AccountBalanceCashRequestButton',

    components: {
      AccountBalanceChip
    }
  };
</script>
